import { formatDateTime, NOTIFICATION_TYPES } from '@crm/shared';
import { Button, Card, CardContent, cn, Spinner } from '@crm/ui';
import { Bell, CheckCheck } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EmptyState, PageHeader } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { useMarkAllRead, useMarkNotificationRead, useNotifications } from '../api';

function rotulo(type: string): string {
  return NOTIFICATION_TYPES.find((item) => item.key === type)?.label ?? type;
}

export function NotificationsPage() {
  useDocumentTitle('Notificacoes');

  const navigate = useNavigate();
  const [somenteNaoLidas, setSomenteNaoLidas] = useState(true);

  const notificacoes = useNotifications({ unread: somenteNaoLidas, limit: 50 });
  const marcarLida = useMarkNotificationRead();
  const marcarTodas = useMarkAllRead();

  return (
    <div className="space-y-5">
      <PageHeader
        icon={<Bell />}
        title="Notificacoes"
        description="O que ficou pendente e ainda nao foi visto."
        actions={
          <Button variant="outline" onClick={() => marcarTodas.mutate()}>
            <CheckCheck className="h-4 w-4" />
            <span className="hidden sm:inline">Marcar todas como lidas</span>
          </Button>
        }
      />

      <div className="flex gap-1">
        {[
          { label: 'Nao lidas', valor: true },
          { label: 'Todas', valor: false },
        ].map((aba) => (
          <button
            key={aba.label}
            type="button"
            onClick={() => setSomenteNaoLidas(aba.valor)}
            className={cn(
              'rounded-full px-3.5 py-1.5 text-sm transition-colors',
              somenteNaoLidas === aba.valor
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-muted',
            )}
          >
            {aba.label}
          </button>
        ))}
      </div>

      <Card variant="flush">
        <CardContent className="p-0">
          {notificacoes.isPending ? (
            <div className="flex justify-center py-14">
              <Spinner />
            </div>
          ) : notificacoes.data?.data.length ? (
            <ul className="divide-y divide-border">
              {notificacoes.data.data.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    className={cn(
                      'w-full px-4 py-3 text-left transition-colors hover:bg-muted/50',
                      item.read ? 'opacity-60' : '',
                    )}
                    onClick={() => {
                      marcarLida.mutate(item.id);
                      if (item.link) navigate(item.link);
                    }}
                  >
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                      <span className="font-medium">{item.title}</span>
                      <span className="text-xs text-muted-foreground">{rotulo(item.type)}</span>
                    </div>
                    <p className="truncate text-sm text-muted-foreground">{item.body}</p>
                    <p className="text-xs text-muted-foreground">
                      {formatDateTime(item.createdAt)}
                    </p>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <EmptyState icon={<Bell />} title="Nada pendente por aqui" />
          )}
        </CardContent>
      </Card>
    </div>
  );
}
